/* 
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Fragment, memo } from 'react';
import Style from './../../css/LoanInfoHeaderModal.module.css';
import { Button } from '@mui/material';
import DefaultModal from './DefaultModal';
import EnvelopeWithBox from '../../components/EnvelopeWithBox';
import ButtonBorderWrapper from '../../components/ButtonBorderWrapper';
import ButtonBorder from '../../components/ButtonBorder';

type WarningModalPropsType = {
  open: boolean;
  handleClose: any;
  warningMessages: string[];
};

const WarningModal = memo((props: WarningModalPropsType) => {
  return (
    <Fragment>
      <DefaultModal
        className={Style.section}
        open={props.open}
        content={
          <ButtonBorderWrapper>
            <EnvelopeWithBox blockName={'Warnings'}>
              <div className={Style.modalContainer}>
                {props.warningMessages.length > 0 ? (
                  <>
                    <h2 className={Style.modalHeader}>Warnings</h2>
                    <ul className={Style.list}>
                      {props.warningMessages.map((warning, index) => (
                        <li key={index} className={Style.listItem}>
                          {warning}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </EnvelopeWithBox>
            <ButtonBorder disabled={false}>
              <Button type='button' onClick={props.handleClose} className={Style.button}>
                Close
              </Button>
            </ButtonBorder>
          </ButtonBorderWrapper>
        }
      />
    </Fragment>
  );
});

export default WarningModal;
